var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center lh-small"},[_c('v-icon',{attrs:{"color":_vm.iconColor,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.item.icon)+" ")]),_c('div',[_c('b',{class:`${_vm.iconColor}--text${_vm.disabled ? '--disabled' : ''}`},[_vm._v(_vm._s(_vm.item.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }